/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { PageTitle } from "../../../_metronic/layout/core";
import { KTSVG } from "../../../_metronic/helpers";

const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className={`card`}>
      <div className="card-body p-0">
        <div className="row">
          <div className="card-p position-relative">
            {/* begin::Row */}
            <div className="row g-0">
              {/* begin::Col */}
              <Link to={"/campaign/list"} className="col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7 main-action">
                <KTSVG
                  path="/media/icons/duotune/general/gen022.svg"
                  className="svg-icon-5x svg-icon-warning my-2"
                />
                <span className="text-warning fw-bold fs-6">
                  کمپین ها
                </span>
              </Link>
              {/* end::Col */}
              {/* begin::Col */}
              <Link to={"/campaign/new"} className="col bg-light-primary px-6 py-8 rounded-2 mb-7 main-action">
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5x svg-icon-primary my-2"
                  />
                  <span className="text-primary fw-bold fs-6">
                    کمپین جدید
                  </span>
              </Link>
              {/* end::Col */}
            </div>
            {/* end::Row */}
            {/* begin::Row */}
            <div className="row g-0">
              {/* begin::Col */}
              <Link to={"/payment/charge"} className="col bg-light-danger px-6 py-8 rounded-2 me-7 main-action">
                <KTSVG
                  path="/media/icons/duotune/finance/fin008.svg"
                  className="svg-icon-5x svg-icon-danger my-2"
                />
                <span className="text-danger fw-bold fs-6 mt-2">
                  شارژ کیف پول
                </span>
              </Link>
              {/* end::Col */}
              {/* begin::Col */}
              <Link to={"/tickets/list"} className="col bg-light-success px-6 py-8 rounded-2 main-action">
                <KTSVG
                  path="/media/icons/duotune/communication/com010.svg"
                  className="svg-icon-5x svg-icon-success my-2"
                />
                <span className="text-success fw-bold fs-6 mt-2">
                  تیکت ها
                </span>
              </Link>
              {/* end::Col */}
            </div>
            {/* end::Row */}
          </div>
        </div>
      </div>
    </div>
    {/* end::Row */}
  </>
);

const DashboardWrapper: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: "MENU.DASHBOARD" })}</PageTitle>
      <DashboardPage />
    </>
  );
};

export { DashboardWrapper };
